export const px2vw = (size, layoutWidth = 1440) => {
  return `${(size / layoutWidth) * 100}vw`;
};
